import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Box, Typography, Grid, ListItem, TextField, Tabs, Tab, Dialog, DialogContent, List, ListItemButton, Collapse, IconButton, Button } from '@mui/material';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from '../../context/ThemeContext';
import BidValue from '../../components/global/BidAsk/BidValue';
import AskValue from '../../components/global/BidAsk/AskValue';
import ProfitLoss from '../../components/global/BidAsk/ProfitLoss';
import AccountSummary from '../components/AccountSummary';
import ModifyPositionModal from '../components/ModifyPositionModal';
import { setEditOrderDetail, setGlobalSymbolID, setGlobalSymbolsData, setModifyPositionDetail, setTradeModalOpen } from '../../store/Slices/globalSymbolSlice';
import moment from 'moment/moment';
import toast from 'react-hot-toast';
import { deleteOrdersData, } from '../../store/Slices/orderPositionSlice';
import { closeOrder, closeOrderPosition, deleteSLTPOrders, } from '../../api/request/dashboard/dashboard';
import TradeModal from '../../components/modal/trading/TradingModal';
import { handleCloseCreateOrder } from '../../store/Slices/panelSlice';
import { addJournalLog } from '../../components/tab/tabview/journal/addJournalLog';
import { getCookies } from '../../services/Cookies';
import { HiBars2 } from 'react-icons/hi2';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Commission from '../../components/global/BidAsk/Commission';
import SideDrawer from '../components/SidebarMenu';
import { IoSearchOutline } from 'react-icons/io5';
import ClosePosition from '../../components/modal/trading/ClosePosition';
import Sltp from '../components/Sltp';
import { useNavigate } from 'react-router-dom';

export default function Trade() {
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { darkMode } = useContext(ThemeContext)
  const positions = useSelector((state) => state.orderPosition.positions, shallowEqual);
  const orderSLTP = useSelector((state) => state.orderPosition.orderSLTP, shallowEqual);
  const { symbols } = useSelector(state => state.watchlist)
  // const { updatePL } = useSelector((state) => state.profitLoss);
  const [stopLosses, setStopLosses] = useState(0.00)
  const [takeProfits, setTakeProfits] = useState(0.00)
  const [showModifyModal, setShowModifyModal] = useState(false);
  const decimalPlaces = 2;
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState(0)
  const [selectedPendingOrder, setSelectedPendingOrder] = useState(null);
  const accountId = localStorage.getItem('accountID');
  const orderPanelOpen = useSelector(state => state.globalSymbol.orderPanelOpen);
  const editOrderDetail = useSelector(state => state.globalSymbol.editOrderDetail);
  const username = getCookies('username')
  const [expandedId, setExpandedId] = useState(null);
  const [searchVisible, setSearchVisible] = useState(false);
  const { accountSummary = [] } = useSelector(state => state.accountSummary, shallowEqual)
  const [closeModalOpen, setCloseModalOpen] = useState(false);
  const [selectedCloseTradeId, setSelectedCloseTradeId] = useState(null);
  const toggleExpand = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };
  const modifyOpen = (position) => {
    setSelectedPosition(position);
    setShowModifyModal(true)
    handleCloseDrawer()
    dispatch(setModifyPositionDetail(position))
  }
  const handleCloseModifyModal = () => {
    setShowModifyModal(false);
  };
  useEffect(() => {
    const selectedSLTPs = orderSLTP?.filter(sltp => sltp.positionId === selectedPosition?.id) || [];
    const sl = selectedSLTPs.map(s => s?.stopLoss?.toFixed(symbols[selectedPosition?.symbolId].digits)).join(', ') || '0.00';
    const tp = selectedSLTPs.map(s => s?.takeProfit?.toFixed(symbols[selectedPosition?.symbolId].digits)).join(', ') || '0.00';

    setStopLosses(sl);
    setTakeProfits(tp);
  }, [orderSLTP, positions, selectedPosition])


  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedPosition(null);
    setSelectedPendingOrder(null);
  };
  const { UserCompleteDetails } = useSelector(state => state.user);

  const offsetToMinutes = (offset) => {
    const [hours, minutes, seconds] = offset.split(":").map(Number);
    return hours * 60 + minutes + Math.sign(hours) * (seconds > 0 ? 1 : 0);
  };

  const formatDateTime = (serverDateTime) => {
    if (!serverDateTime) return "--";

    const serverTime = moment.parseZone(serverDateTime);
    const serverOffsetMin = offsetToMinutes(UserCompleteDetails?.serverGMTOffset || "00:00:00");
    const clientOffsetMin = offsetToMinutes(UserCompleteDetails?.gmtOffset || "00:00:00");
    const diffOffset = clientOffsetMin - serverOffsetMin;

    return serverTime.add(diffOffset, "minutes").format("DD-MM-YYYY HH:mm:ss");
  };
  const filteredPositions = positions.filter((pos) => {
    const query = searchQuery.toLowerCase();
    const symbolMatch = pos.symbolName.toLowerCase().includes(query);
    const idMatch = pos.id.toString().includes(query);
    return symbolMatch || idMatch;
  });
  const orders = useSelector((state) => state.orderPosition.orders, shallowEqual);

  const enrichedOrders = orders.length ? orders?.map(order => {
    const matchingSymbol = Object.values(symbols).find(symbol => Number(symbol.id) === Number(order.symbolId));
    return {
      ...order,
      currentPrice: matchingSymbol?.bid || "N/A"
    };
  }) : [];
  const combinedData = useMemo(() => {
    const sltpOrders = Array.isArray(orderSLTP) ? orderSLTP : [];
    const merged = [...enrichedOrders, ...sltpOrders];

    return merged
  }, [enrichedOrders, orderSLTP]);
  const filteredCombinedData = useMemo(() => {
    const query = searchQuery.toLowerCase();

    return combinedData.filter((order) => {
      const symbolMatch = order.symbolName?.toLowerCase().includes(query);
      const idMatch = order.id?.toString().includes(query);
      return symbolMatch || idMatch;
    });
  }, [combinedData, searchQuery]);
  const handleCloseClick = async (item) => {
    if (!item?.id) {
      toast.error("No order selected");
      return;
    }

    const rowId = item.id;
    const selectedRow = item;
    if (!selectedRow) {
      toast.error("Order not found");
      return;
    }

    try {
      const payload = { accountId: Number(accountId), id: selectedRow.id };
      let closeResponse;
      let isSLTP = false;

      if (selectedRow.positionId) {
        isSLTP = true;
        closeResponse = await deleteSLTPOrders(payload);
      } else {
        closeResponse = await closeOrder(payload);
      }

      const responseMessage = closeResponse?.data?.message || closeResponse?.message || "";

      if (closeResponse.status === 200) {
        dispatch(deleteOrdersData(rowId));
        // toast.success(responseMessage || `Order #${selectedRow.id} has been canceled successfully.`);
      } else {
        const genericStatus = closeResponse?.status;

        if (genericStatus && genericStatus !== 200) {
          toast.error("Order closure restricted to administrators.");
        } else {
          if (isSLTP) {
            addJournalLog('deleteManageOrderError', `Delete Pending order: #${selectedPosition.id} failure: ${responseMessage}, Account ${username}: ${accountId}.`);
          } else {
            addJournalLog('cancelOrderError', `Cancel Order: #${selectedRow.id} failure: ${responseMessage}, Account ${username}: ${accountId}.`);
          }

          toast.error(responseMessage || `Failed to close order #${selectedRow.id} (${symbols[selectedRow.symbolId]?.name || "Unknown"})`);
        }
      }
    } catch (error) {
      console.error("Error closing order:", error);
      const backendMessage = error?.response?.data?.message || error.message || "Unknown error occurred";

      if (selectedRow.positionId) {
        addJournalLog('deleteManageOrderError', `Delete Pending order: #${selectedPosition.id} failure: ${backendMessage}, Account ${username}: ${accountId}.`);
      } else {
        addJournalLog('cancelOrderError', `Cancel Order: #${selectedRow.id} failure: ${backendMessage}, Account ${username}: ${accountId}.`);
      }

      toast.error(`Order #${rowId} failed: ${backendMessage}`);
    }
  };

  // const handleEditOrderClick = () => {
  //   if (selectedPendingOrder) {
  //     dispatch(setEditOrderDetail(selectedPendingOrder));
  //     dispatch(setTradeModalOpen(true));
  //   } else {
  //     toast.error("No order selected.");
  //     dispatch(setEditOrderDetail(null));
  //   }
  // };
  const handleEditOrderClick = (item) => {
    if (item) {
      dispatch(setEditOrderDetail(item));
      dispatch(setTradeModalOpen(true));
    } else {
      toast.error("No order selected.");
      dispatch(setEditOrderDetail(null));
    }
  };

  const handleCloseCreateOrderPanel = () => {
    dispatch(handleCloseCreateOrder());
    dispatch(setTradeModalOpen(false))
  };
  const closeModal_ClosePosition = () => {
    setCloseModalOpen(false);
  }
  const handleCloseClickPosition = async (rowIndex = null, orderId = null, customAmount = null) => {
    const ordersToClose = orderId ? [orderId] : rowIndex !== null ? [positions[rowIndex]?.id] : selectedPosition;

    if (ordersToClose.length === 0) {
      toast.error("No trades selected");
      return;
    }

    const closeRequests = ordersToClose.map(async (orderId) => {
      const selectedRow = positions.find(row => row.id === orderId);
      if (!selectedRow) return { success: false, positionId: orderId };

      const closeOrderPayload = {
        accountId: Number(accountId),
        positionId: selectedRow.id,
        amount: customAmount ?? selectedRow.amount,
      };

      try {
        const response = await closeOrderPosition(closeOrderPayload);
        if (response.status === 200) {
          // dispatch(deletePositionsData(orderId));
          // addJournalLog('tradeClosed', `Position closed #${selectedPosition.id}`);
          return { success: true, positionId: orderId, position: selectedRow, message: response?.data?.message || "Unexpected error" };
        }
      } catch (error) {
        const apiMessage = error?.response?.data?.message || error?.message || "Unknown error";
        console.error("Error closing order:", error);
        addJournalLog('closePositionError', `Close position: #${selectedRow.id} failure: ${error}, Account ${username}: ${accountId}.`);
        return { success: false, positionId: orderId, position: selectedRow, message: apiMessage, };
      }
      return { success: false, positionId: orderId, position: selectedRow };
    });

    const results = await Promise.allSettled(closeRequests);

    results.forEach(({ status, value }) => {
      if (status === "fulfilled" && value?.success) {
        const { positionId, position } = value;
        if (position) {
          const { symbolId, symbolName, side, profitLoss } = position;
          const price = side === 1 ? symbols[symbolId]?.bid : symbols[symbolId]?.ask;
          const tradeSide = side === 1 ? "Buy" : "Sell";

          // toast.success(`Closed Trade #${positionId} (${symbolName}) at ${price}, ${tradeSide} , amount ${customAmount || position.amount}, P/L ${profitLoss}`);
        }
      } else {
        const { positionId, position, message } = value;
        if (position) {
          const { symbolId, symbolName, side } = position;
          const price = side === 1 ? symbols[symbolId]?.bid : symbols[symbolId]?.ask;

          toast.error(` Failed to close Trade #${positionId} (${symbolName}) at ${price} due to: ${message || "unknown error"}`);
        }
      }
    });
  };
  const handleConfirmClose = async (amount) => {
    await handleCloseClickPosition(null, selectedCloseTradeId, amount);
    setCloseModalOpen(false);
  };

  const handleClosePositionMenuClick = () => {
    if (selectedPosition) {
      setSelectedPosition(selectedPosition);
      setSelectedCloseTradeId(selectedPosition?.id);
      setCloseModalOpen(true);
    } else {
      toast.error("No trade selected to close.");
    }
  };
  const handleChartFromTradeTabClick = (item) => {
    const symbol = symbols[item.symbolId];
    if (!symbol) return;

    dispatch(setGlobalSymbolsData(symbol));
    dispatch(setGlobalSymbolID(symbol.id));
    navigate("/chart");
  };
  useEffect(() => {
    if (!showModifyModal && !closeModalOpen) {
      setSelectedPosition(null);
      setSelectedCloseTradeId(null);
      setSelectedPendingOrder(null);
    }
  }, [showModifyModal, closeModalOpen]);

  const bgImage = '/BG.png'
  const renderItem = (item, isOrder = false) => {
    const isExpanded = expandedId === item.id;
    const digits = symbols[item.symbolId]?.digits || 2;
    const sltpList = !isOrder ? orderSLTP?.filter((sltp) => sltp.positionId === item.id) || [] : [];


    return (
      <React.Fragment key={item.id}>
        <ListItem disablePadding sx={{ flexDirection: 'column', alignItems: 'stretch', backgroundColor: darkMode ? "#151924" : 'var(--white)', cursor: 'pointer', }}>
          <ListItemButton onClick={() => toggleExpand(item.id)}>
            <Box flexGrow={1}>
              <Typography variant="body2" fontWeight="bold" sx={{ color: darkMode ? "var(--white)" : 'var(--black)' }}>
                {item.symbolName}{" "}
                <span style={{ color: (item.type > 0 || item.side === 1) ? 'var(--primary)' : '#da5244' }}>
                  {isOrder
                    ? (item.type !== undefined && item.type !== null
                      ? item.type === 1 ? `${t('BuyLimit')}`
                        : item.type === -1 ? `${t('SellLimit')}`
                          : item.type === 2 ? `${t('BuyStop')}`
                            : item.type === -2 ? `${t('SellStop')}` : '-'
                      : item.side === 1 ? `${t('buy')} (manage)`
                        : item.side === -1 ? `${t('sell')} (manage)` : '-')
                    : item.side === 1 ? `${t('buy')}`
                      : item.side === -1 ? `${t('sell')}` : '-'}{' '}
                  {item.amount?.toFixed?.(decimalPlaces) || '0.00'}
                </span>
              </Typography>
              <Typography variant="caption" sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}>
                {isOrder ? (
                  <>
                    {item?.price?.toFixed(digits)} →{" "}
                    {item?.side === 1
                      ? <BidValue symbolId={item.symbolId} digits={digits} />
                      : <AskValue symbolId={item.symbolId} digits={digits} />}
                  </>
                ) : (
                  <>
                    {item.openPrice?.toFixed(digits)} →{" "}
                    {item.side === 1
                      ? <BidValue symbolId={item.symbolId} digits={digits} />
                      : <AskValue symbolId={item.symbolId} digits={digits} />}
                  </>
                )}
              </Typography>
            </Box>
            <ProfitLoss row={item} />
            {isExpanded ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>

          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <Box p={2} sx={{ pt: 0 }}>
              <Grid container justifyContent="space-between">
                <Typography variant="caption">ID:</Typography>
                <Typography variant="caption">{item.id}</Typography>
              </Grid>

              <Grid container justifyContent="space-between">
                <Typography variant="caption">Commission:</Typography>
                <Typography variant="caption"><Commission row={item} /></Typography>
              </Grid>

              <Grid container justifyContent="space-between">
                <Typography variant="caption"> {t('swap')}</Typography>
                <Typography variant="caption">{item?.interest ? item?.interest.toFixed(2) : '0.00'}</Typography>
              </Grid>
              {isOrder ? (
                <>
                  <Grid container justifyContent="space-between">
                    <Typography variant="caption">S/L:</Typography>
                    <Typography variant="caption">{item.stopLoss ?? '—'}</Typography>
                  </Grid>

                  <Grid container justifyContent="space-between">
                    <Typography variant="caption">T/P:</Typography>
                    <Typography variant="caption">{item.takeProfit ?? '—'}</Typography>
                  </Grid>
                </>
              ) : (sltpList.length > 0 && (null))}
              <Grid container justifyContent="space-between">
                <Typography variant="caption">Date/Time:</Typography>
                <Typography variant="caption">{formatDateTime(item.dateTime)}</Typography>
              </Grid>

              <Grid container justifyContent="space-between">
                <Typography variant="caption">Comment:</Typography>
                <Typography variant="caption">{item.comment}</Typography>
              </Grid>

              {isOrder ? null : (sltpList.length > 0 ? (<Sltp editSLTP={sltpList} />) : null)}
              <Box mt={2} display="flex" justifyContent="center" gap={2}>
                {isOrder ? (
                  <>
                    {!item.positionId && (<Button sx={{ textTransform: 'none' }} size="small" variant="outlined" onClick={(e) => { e.stopPropagation(); setSelectedPendingOrder(item); handleEditOrderClick(item); dispatch(setEditOrderDetail(item)); dispatch(setTradeModalOpen(true)); }}>{t('editOrder')}</Button>)}
                    <Button sx={{ textTransform: 'none' }} size="small" variant="outlined" color="error" onClick={(e) => { e.stopPropagation(); handleCloseClick(item); }}>{t('cancelOrder')}</Button>
                  </>
                ) : (
                  <>
                    <Button sx={{ textTransform: 'none' }} size="small" variant="outlined" onClick={(e) => { e.stopPropagation(); modifyOpen(item); }}>{t('modifyPosition')}</Button>
                    <Button sx={{ textTransform: 'none' }} size="small" variant="outlined" color="error" onClick={() => { setSelectedPosition(item); setSelectedCloseTradeId(item?.id); setCloseModalOpen(true); }}>{t('close')}</Button>
                    <Button sx={{ textTransform: 'none' }} size="small" variant="outlined" color="error" onClick={() => handleChartFromTradeTabClick(item)}>{t('chart')}</Button>
                  </>
                )}
              </Box>
            </Box>

          </Collapse>
        </ListItem>
      </React.Fragment>
    );
  };
  return (
    <Box sx={{ height: '100vh', overflow: 'hidden', backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center', display: 'flex', flexDirection: 'column', pb: `56px`, }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, }}>
        <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 1.5, p: 0.5 }}>
          <HiBars2 onClick={() => setDrawerOpen(true)} style={{ fontSize: 24, color: 'white' }} />
          <Typography color='white' variant='body1' sx={{ fontSize: 18 }}> {t('trades')}</Typography>
        </Box>
        <Typography color="white" variant="body2" sx={{ fontWeight: 500, fontSize: 14 }}>{t('TotalBalance')}: {accountSummary?.balance?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) ?? '0.00'}</Typography>
      </Box>
      <Box sx={{ overflow: 'hidden', backgroundColor: darkMode ? "#202933" : '#fff', flexGrow: 1, display: 'flex', flexDirection: 'column', }}>
        <AccountSummary></AccountSummary>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: darkMode ? "#202933" : "#f1f1f1", }}>
          <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)} variant="" sx={{ backgroundColor: darkMode ? "#202933" : "#f1f1f1" }}>
            <Tab label={t('trades')} sx={{ textTransform: 'none' }} />
            <Tab label={t('orders')} sx={{ textTransform: 'none' }} />
          </Tabs>
          <Box sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
            {searchVisible ? (
              <TextField variant="outlined" size="small" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} placeholder={t('search')} sx={{ width: 160, transition: 'width 0.3s ease', backgroundColor: darkMode ? '#2d3748' : '#fff', borderRadius: 1, ml: 1, '& .MuiOutlinedInput-root': { px: 1, py: 0.5, fontSize: 13, }, }} />
            ) : null}
            <IconButton onClick={() => setSearchVisible(!searchVisible)} size="small" sx={{ ml: 1 }}>
              <IoSearchOutline style={{ fontSize: 20, color: darkMode ? '#fff' : '#000' }} />
            </IconButton>
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
          <List sx={{ pt: 0, pb: 0 }}>
            {activeTab === 0
              ? filteredPositions.length
                ? filteredPositions.map((pos) => renderItem(pos))
                : <Typography textAlign="center" mt={2}>{t("noMatchingResults")}</Typography>
              : filteredCombinedData.length
                ? filteredCombinedData.map((order) => renderItem(order, true))
                : <Typography textAlign="center" mt={2}>{t("noMatchingResults")}</Typography>
            }
          </List>
        </Box>
      </Box>
      {orderPanelOpen && editOrderDetail && (
        <Dialog open={true} onClose={handleCloseCreateOrderPanel} maxWidth="lg" fullWidth>
          <DialogContent sx={{ p: 0 }}>
            <TradeModal open={true} onClose={handleCloseCreateOrderPanel} showCloseButton={true} />
          </DialogContent>
        </Dialog>
      )}
      <ModifyPositionModal open={showModifyModal} onClose={handleCloseModifyModal} onOrderModified={false} />
      <SideDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      {closeModalOpen && (<ClosePosition open={closeModalOpen} onClose={closeModal_ClosePosition} selectedPosition={selectedPosition} onConfirm={handleConfirmClose} />)}
    </Box>
  );
}
